export default __webpack_public_path__ + "static/gallery-art-comic-6e65a79f163663c27681bbe74a6bd384.jpg";